import { DrawerItemSubtitle } from '../object-drawer/drawer-item-subtitle';

export class SectionContainerConfig {
  public title: string = '';
  public itemTypeName: string = '';
  public itemIdField: string = '';
  public itemParentIdField: string = '';
  public itemTitleField: string = '';
  public itemSubtitles: DrawerItemSubtitle[] = [];
  public enableAdd: boolean = false;
  public showCopyItem: boolean = false;
  public enableFilter: boolean = false;
  public totalItemCount: number = 0;
  public pageSize: number = 50;
  public hasFilters: boolean = true;
  public showSelectedItemText: boolean = false;
  public showTreeView: boolean = true;
  public hasBreadcrumbs: boolean = true;
  public showBreadcrumbsWithoutSelection: boolean = false;
  public outputObject: boolean = false;
  public showActionsWithoutSelection: boolean = false;
  public showNavigationButtons: boolean = false;

  private _treeTitleField: string;

  get treeTitleField(): string {
    return this._treeTitleField ? this._treeTitleField : this.itemTitleField;
  }

  set treeTitleField(value: string) {
    this._treeTitleField = value;
  }
}
